import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-grants-accounting',
  templateUrl: './grants-accounting.component.html',
  styleUrls: ['./grants-accounting.component.scss']
})
export class GrantsAccountingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
